if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.elHero = this.closest('.product-hero');
            this.elVariantAccordionItems = this.elHero.querySelectorAll('[data-variant-accordions-item]');
            this.elForm = this.querySelector('[data-product-form]');
            this.elVariants = this.querySelector('variant-selector');
            this.elId = this.querySelector('input[name="id"]');
            this.elAtc = this.querySelector('[data-atc]');
            this.elAtcText = this.elAtc.querySelector('[data-cta]');
            this.elPrice = this.querySelector('[data-price]');
            this.elCap = this.querySelector('[data-cap]');
            this.elWaitlistToggle = this.querySelector('[data-waitlist-toggle]');
            this.elWaitlist = this.querySelector('product-waitlist');

            this.url = new URL(window.location);

            this.waitlistEnabled = this.getAttribute('waitlist-enabled') == "true";
            this.waitlistEnabled && this.elWaitlistToggle.addEventListener('click', this.toggleWaitlist.bind(this));

            this.cartData = {
                id: this.elId.value,
                quantity: 1,
            }

            this.elVariants && this.elVariants.addEventListener('variant:changed', this.updateCurrentVariant.bind(this));
            this.elForm.addEventListener('submit', this.addToCart.bind(this));
        }

        updateCurrentVariant(ev) {
            const { detail: variant } = ev;

            if (!variant) return;

            this.elId.value = variant.id;
            this.elPrice.innerHTML = variant.price;
            this.elCap.innerHTML = variant.compare_at_price ? variant.compare_at_price : "";
            this.elAtc.disabled = !variant.available;
            this.elAtcText.innerHTML = variant.available ? 'Add to Cart' : this.waitlistEnabled ? 'Waitlist' : 'Sold Out';

            if (this.waitlistEnabled) {
                this.elWaitlistToggle.classList.toggle('has-cap', !!variant.compare_at_price);

                this.elWaitlistToggle.toggleAttribute('hidden', variant.available);
                this.elWaitlist && this.elWaitlist.toggleAttribute('hidden', variant.available);
                this.elWaitlist && this.elWaitlist.setAttribute('variant-id', variant.id);
                if (variant.available && this.elWaitlist.classList.contains('open')) {
                    this.elWaitlist.classList.remove('open');
                    this.elWaitlist.classList.remove('visible');
                    this.elWaitlistToggle.setAttribute('aria-expanded', false);
                }
            }

            this.cartData.id = variant.id;
            this.updateVariantAccordions(variant.id);
            this.updateURL();
        }

        addToCart(ev) {
            ev.preventDefault();
            const elCartDrawer = document.querySelector('cart-drawer');
            elCartDrawer.addToCart(this.elAtc, this.cartData);
        }

        toggleWaitlist(ev) {
            ev.preventDefault();
            const isOpen = this.elWaitlist.classList.contains('open');
            if (isOpen) {
                this.elWaitlistToggle.setAttribute('aria-expanded', false);
                this.elWaitlist.classList.remove('open');
                this.elWaitlist.ontransitionend = () => {
                    this.elWaitlist.classList.remove('visible');
                    this.elWaitlist.ontransitionend = null;
                }
            } else {
                this.elWaitlist.classList.add('visible');
                this.elWaitlistToggle.setAttribute('aria-expanded', true);
                this.elWaitlist.classList.add('open');
            }
        }

        updateVariantAccordions(variantId) {
            if (!this.elVariantAccordionItems.length) return;

            this.elVariantAccordionItems.forEach(el => {
                const isMatch = el.dataset.variantId === String(variantId);
                el.toggleAttribute('hidden', !isMatch);
            });
        }

        updateURL() {
            const { id: variantId } = this.cartData;
            this.url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', this.url);
        }
    }

    customElements.define('product-form', ProductForm);
}